import React from 'react';
import { useHistory } from 'react-router';
import { NavBar, Icon, Modal } from 'antd-mobile';
import './index.scss';
const alert = Modal.alert;
const Vh5Bar = props => {
	let history = useHistory();
	let {
		backCallback = () => {
			let flag = (checkPageBeat && checkPageBeat()) || false;
			let _privateCallback = () => {
				let pathname = history.location.pathname;
				history.goBack();
			};
			if (flag) {
				alert('保存提醒', '尚未保存，是否返回？', [
					{ text: '取消', onPress: () => {} },
					{
						text: '确认',
						onPress: () => {
							_privateCallback();
						}
					}
				]);
				return;
			}
			_privateCallback();
		},
		saveCallback = () => {},
		barContentText,
		barRightText,
		checkPageBeat,
		kvalue,
		bottomLine
	} = props;
	return (
		<div className={'vbar-wrap ' + (bottomLine ? 'v-bt1' : '')}>
			<NavBar
				className="bar"
				mode="dark"
				icon={<Icon className="icon-left" type="left" />}
				onLeftClick={() => backCallback()}
				rightContent={[
					barRightText ? (
						<span key={kvalue || 'vbar'} className="back" onClick={saveCallback}>
							{barRightText}
						</span>
					) : (
						''
					)
				]}>
				{barContentText || ''}
			</NavBar>
		</div>
	);
};
export { Vh5Bar };
